
export default {
  props: {
    label: {
      type: String,
      required: true,
      default: '',
    },
    selected: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {
    this.$emit('tagMounted')
  },
  methods: {
    onClick() {
      if (!this.disabled) {
        this.$emit('onChange', {
          label: this.label,
          selected: !this.selected,
        })
      }
    },
  },
}
